import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/@shared';
import { TranslateModule } from '@ngx-translate/core';
import { SRodoDescriptionComponent } from './s-rodo-description.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Shell } from '@app/shell/shell.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

const routes: Routes = [
  Shell.childRoutes([{ path: 'rodo', component: SRodoDescriptionComponent, data: { title: marker('RODO') } }]),
];

@NgModule({
  declarations: [SRodoDescriptionComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes), TranslateModule, FormsModule],
  exports: [SRodoDescriptionComponent],
})
export class SRodoDescriptionModule {}
